import { LOCAL_STORAGE_NAMES, UI_LANGUAGE_TAGS } from './constants';

// Resolved on every call, never cached: Office.context.displayLanguage is only populated once
// Office.onReady has fired, which happens after every module in the bundle has been imported.
// Only used as the bootstrap fallback for uiLanguage (see UserContext) — no longer for formatting.
export function getHostLocale(): string {
  const officeLocale = typeof Office === 'undefined' ? undefined : Office.context?.displayLanguage;
  if (officeLocale) return officeLocale;

  const [preferredBrowserLocale] = navigator.languages ?? [];
  if (preferredBrowserLocale) return preferredBrowserLocale;

  if (navigator.language) return navigator.language;

  return 'en-US';
}

// The UI's active display language, resolved fresh from localStorage on every call so a change
// made elsewhere (LanguageContext) is picked up without threading React state into this module.
export const getDisplayLanguageLocale = (): string => {
  const language = localStorage.getItem(LOCAL_STORAGE_NAMES.language) ?? 'en';
  return UI_LANGUAGE_TAGS[language] ?? 'en-US';
};

// The account's uiRegionalFormat preference. Set once by UserContext when the profile loads or
// changes; there's no client-side default because the API always returns a region for every user.
let resolvedRegionLocale: string | undefined;

export const setRegionLocale = (region: string | undefined): void => {
  resolvedRegionLocale = region;
};

export const getRegionLocale = (): string => resolvedRegionLocale ?? 'en-US';
